module.exports = __webpack_public_path__ + "img/solveSolution.5b833298.png";